import { ViperSelect } from "@/components";
import { suggestionsType } from "@/propTypes";
import { arrayOf, bool, element, func, string } from "prop-types";
import { useEffect, useState } from "react";

const AutoCompleteInput = ({
  onInputChange,
  onFetchSuggestions,
  suggestions,
  placeholder,
  selectedSuggestionValue,
  loading,
  customOptions,
  optionLabelProp,
}) => {
  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    const suggestionHasBeenSelected =
      !inputValue || inputValue === selectedSuggestionValue;
    if (suggestionHasBeenSelected) {
      setInputValue(null);
    }
  }, [inputValue, selectedSuggestionValue]);

  const handleChange = (value) => {
    onInputChange(value);
    setInputValue(value);
  };

  return (
    <ViperSelect
      data-test-id="auto-complete-dropdown"
      onChange={handleChange}
      onFetchSuggestions={onFetchSuggestions}
      suggestions={suggestions}
      placeholder={placeholder || undefined}
      loading={loading}
      value={inputValue}
      customOptions={customOptions}
      optionLabelProp={optionLabelProp}
    />
  );
};

AutoCompleteInput.propTypes = {
  onInputChange: func.isRequired,
  onFetchSuggestions: func.isRequired,
  suggestions: suggestionsType,
  selectedSuggestionValue: string,
  loading: bool,
  placeholder: string,
  customOptions: arrayOf(element),
  optionLabelProp: string,
};

export default AutoCompleteInput;
